/* ==========================================================================
   CUTMORE — Damastmesser Produktseite: Griff-Wechsel ueber die ganze Seite
   Angelegt 08.10.2026. Geladen von sections/cutmore-damast-hero.liquid.

   - Die Griff-Wahl im Kaufblock setzt die Variante (Olivenholz/Pakkaholz).
   - CutmoreDamast.setGriff(key) blendet auf der GANZEN Seite alle Elemente
     mit [data-griff-only] passend ein/aus (Galerie, Section-Bilder, Texte).
   - "ProSharp dazu" und "Beides in den Warenkorb" legen beide Artikel per
     /cart/add.js in den Warenkorb und leiten auf /cart weiter. Faellt das
     aus, greift das normale Formular (nur Messer).
   - "Beides in den Warenkorb" ist gesperrt, solange der gewaehlte Griff
     nicht lieferbar ist.
   ========================================================================== */
(function () {
  'use strict';

  var D = window.CutmoreDamast = window.CutmoreDamast || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  D.setGriff = function (key) {
    if (!key) return;
    D.griff = key;
    document.documentElement.setAttribute('data-griff', key);
    each(document.querySelectorAll('[data-griff-only]'), function (el) {
      el.hidden = el.getAttribute('data-griff-only') !== key;
    });
    document.dispatchEvent(new CustomEvent('cutmore:griff', { detail: { key: key, variant: D.variant || null } }));
  };

  D.addItems = function (items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      window.location.href = ROOT + 'cart';
    });
  };

  D.currentVariantId = function () {
    if (D.variant) return D.variant.id;
    var input = document.querySelector('[data-dm-variant-id]');
    return input ? parseInt(input.value, 10) : null;
  };

  function initHero(root) {
    if (root.__dmInit) return;
    root.__dmInit = true;

    var dataEl = root.querySelector('[data-dm-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.querySelector('[data-dm-form]');
    var idInput = root.querySelector('[data-dm-variant-id]');
    var qtyInput = root.querySelector('[data-dm-qty]');
    var main = root.querySelector('[data-dm-main]');
    var thumbs = root.querySelectorAll('[data-dm-thumb]');
    var submit = root.querySelector('[data-dm-submit]');
    var stock = root.querySelector('[data-dm-stock]');
    var sticky = document.querySelector('[data-dm-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-dm-sticky-submit]') : null;

    function byKey(k) {
      for (var i = 0; i < variants.length; i++) { if (variants[i].key === k) return variants[i]; }
      return null;
    }
    function byId(id) {
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) return variants[i]; }
      return null;
    }

    function showMain(t) {
      if (!main || !t) return;
      main.src = t.getAttribute('data-full');
      main.setAttribute('srcset', t.getAttribute('data-srcset') || '');
      main.alt = t.getAttribute('data-alt') || '';
      each(thumbs, function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
    }
    each(thumbs, function (t) { t.addEventListener('click', function () { showMain(t); }); });

    function apply(v) {
      if (!v) return;
      D.variant = v;
      if (idInput) idInput.value = v.id;

      each(document.querySelectorAll('[data-dm-price]'), function (el) { el.textContent = v.price; });
      each(document.querySelectorAll('[data-dm-compare]'), function (el) {
        el.textContent = v.compare || '';
        el.hidden = !v.compare;
      });
      each(document.querySelectorAll('[data-dm-griff-name]'), function (el) { el.textContent = v.title; });

      var label = v.available ? (submit ? submit.getAttribute('data-label-on') : '') : (submit ? submit.getAttribute('data-label-off') : '');
      [submit, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        if (label) b.textContent = label;
      });
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        var txt = stock.querySelector('[data-dm-stock-text]');
        if (txt) txt.textContent = v.available ? stock.getAttribute('data-on') : stock.getAttribute('data-off');
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      D.setGriff(v.key);

      var first = null;
      each(thumbs, function (t) { if (!first && !t.hidden) first = t; });
      showMain(first);
    }

    each(root.querySelectorAll('[data-dm-griff-input]'), function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(byKey(r.value)); });
    });

    each(root.querySelectorAll('[data-dm-q]'), function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10) || 1;
        n = b.getAttribute('data-dm-q') === '+' ? n + 1 : Math.max(1, n - 1);
        qtyInput.value = n;
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var addon = root.querySelector('[data-dm-addon]');
        if (!addon || !addon.checked) return;
        e.preventDefault();
        var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        D.addItems([
          { id: parseInt(idInput.value, 10), quantity: qty },
          { id: parseInt(addon.value, 10), quantity: 1 }
        ]).catch(function () { form.submit(); });
      });
    }

    // Sticky-Kaufleiste: sichtbar, sobald der Kaufbutton aus dem Bild ist
    if (sticky && submit && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top > 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && !below);
          sticky.setAttribute('aria-hidden', en.isIntersecting || below ? 'true' : 'false');
        });
      });
      io.observe(submit);
    }

    var start = idInput ? byId(parseInt(idInput.value, 10)) : null;
    D.variant = start || variants[0] || null;
    if (D.variant) document.documentElement.setAttribute('data-griff', D.variant.key);
  }

  function initPair(root) {
    if (root.__dmInit) return;
    root.__dmInit = true;
    var btn = root.querySelector('[data-dm-pair-add]');
    if (!btn) return;
    function sync() { btn.disabled = !!(D.variant && !D.variant.available); }
    sync();
    document.addEventListener('cutmore:griff', sync);
    btn.addEventListener('click', function () {
      var knife = D.currentVariantId();
      var addon = parseInt(btn.getAttribute('data-addon'), 10);
      if (!knife || !addon) return;
      btn.disabled = true;
      D.addItems([{ id: knife, quantity: 1 }, { id: addon, quantity: 1 }]).catch(function () {
        btn.disabled = false;
        window.location.href = btn.getAttribute('data-fallback') || (ROOT + 'cart');
      });
    });
  }

  function init(scope) {
    each((scope || document).querySelectorAll('[data-dm-hero]'), initHero);
    each((scope || document).querySelectorAll('[data-dm-pair]'), initPair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
